import { useState, useEffect } from "react";
import Item from "./Item";
import { v4 as uuidv4 } from "uuid";

export default function Form() {
  // const [dataArr, setDataArr] = useState([
  //   { txt: "Promener le chien", id: uuidv4() },
  //   { txt: "Sport", id: uuidv4() },
  //   { txt: "Coder avec React", id: uuidv4() },
  // ]);

  const [dataArr, setDataArr] = useState([]);
  const [tempDataArr, setTempDataArr] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const localDataArr = JSON.parse(localStorage.getItem("localDataArr")) || [];

    if (localDataArr.length !== 0) {
        setDataArr(localDataArr);
        setTempDataArr(localDataArr);
    }
  }, []);

  const [stateInput, setStateInput] = useState("");

  const storeList = (items) => {
    localStorage.setItem("localDataArr", JSON.stringify(items));
  };


  const addTodo = (e) => {
    e.preventDefault();
    if (stateInput === "") return;
    
    const newItem = {
      txt: stateInput,
      id: uuidv4(),
    };

    setDataArr(prevItems => {
      const updatedItems = [...prevItems, newItem];
      storeList(updatedItems); // Appeler storeList avec les items mis à jour
      return updatedItems;
    });

    setTempDataArr(prevItems => {
      const updatedItems = [...prevItems, newItem];
      storeList(updatedItems); // Appeler storeList avec les items mis à jour
      return updatedItems;
    });

    setStateInput("");
  };


  const deleteElement = (id) => {
    // console.log(id);
    setDataArr(prevItems => {
      const updatedItems = prevItems.filter(item => item.id !== id);
      storeList(updatedItems); // Appeler storeList avec les items mis à jour
      return updatedItems;
    });

    setTempDataArr(prevItems => {
      const updatedItems = prevItems.filter(item => item.id !== id);
      storeList(updatedItems); // Appeler storeList avec les items mis à jour
      return updatedItems;
    });
  };


  const linkedInput = (value) => {
    setStateInput(value);
  };


  const selectATask = () => {
    if (dataArr.length === 0) return;
    let randomIndex = Math.floor(Math.random() * dataArr.length);
    while (randomIndex === index) {
      randomIndex = Math.floor(Math.random() * dataArr.length);
    }
    const randomTask = dataArr[randomIndex];
    setIndex(randomIndex);
    setDataArr([randomTask]);
  };


  const displayAll = () => {
    setDataArr(tempDataArr);
  };


  return (
    <div className="m-auto px-4 col-12 col-sm-10 col-lg-6">
      <form onSubmit={(e) => addTodo(e)} className="mb-3">
        <label htmlFor="todo" className="form-label mt-3">
          Chose à faire
        </label>
        <input
          value={stateInput}
          onChange={(e) => linkedInput(e.target.value)}
          type="text"
          className="form-control"
          id="todo"
        />

        <button className="mt-2 btn btn-primary d-block">Ajouter</button>
      </form>

      <div className="border d-flex justify-content-between align-items-center p-2 mb-4">
        <div className="p-2">Sélectionner une tâche aléatoirement</div>
        <button
          className="btn btn-success p-2 h-50"
          onClick={selectATask}
        >
        Sélectionner
        </button>
      </div>

      <div className="border d-flex justify-content-between align-items-center p-2 mb-4">
        <div className="p-2">Afficher toutes les tâches</div>
        <button
          className="btn btn-success p-2 h-50"
          onClick={displayAll}
        >
        Tout Afficher
        </button>
      </div>

      <h2>Liste des choses à faire : </h2>
      <ul className="list-group">
        {dataArr.map((item) => {
          return (
            <Item
              txt={item.txt}
              key={item.id}
              id={item.id}
              delFunc={deleteElement}
            />
          );
        })}
      </ul>
    </div>
  );
}
